import React from 'react'
import { StyledLayout } from './styles'

interface IProps {
  children: React.ReactNode
}

/**
 * This layout includes no decoration at all and can be used before a user has
 * logged in.
 */
export const GuestLayout: React.FC<IProps> = ({ children }: IProps) => (
<StyledLayout>{children}</StyledLayout>
)

export default GuestLayout
